/*eslint-disable*/
import { NavBar } from 'components/NavBar/NavBar';
import { Button, Flex, HeadlineFlex, MainHeadline, PageWrapper, Table, TablesGrid, Th, Tr } from 'styling/GlobalStyles';
import { FoodTableContainer } from './Food.styled';
import { BodyText } from 'styling/Typography';
import { useEffect, useState } from 'react';
import { MealTypeModal } from './MealTypeModal';
import { IMealSupplierModalState, MealSuppliersModal } from './MealSuppliersModal';
import { IngredientsModal } from './IngredientsModal';
import { DishesModal } from './DishesModal';
import { AppDispatch, RootState } from 'store';
import { clearFood, deleteDish, deleteIngredient, deleteMealSupplier, deleteMealType, getDishes, getMealIngredients, getMealSuppliers, getMealTypes } from 'features/food/foodSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination } from 'components/Pagination/Pagination';
import { handlePagination } from 'utils/helpers';
import { Td } from 'components/Td/Td';
import { IGetAllDishesSingleResponse, IIngredientSingleResponse, IMealSupplierSingleResponse } from 'types/api/foodApi.interface';
import { Options } from 'components/Options/Options';
import { dietaryPreferences } from './foodData';
import { setConfirmModal } from 'features/global/globalSlice';
import { ModalTypes } from 'types/global.interface';
import { NoItems } from 'components/NoItems-fallback/NoItems';
import { INameId } from 'constants/globalTypes';
import { useNavigate } from 'react-router-dom';
import { ActionsMenu } from 'components/ActionsMenu/ActionsMenu';
import { ActionsMenuBreakpoint, HideOnBreakpoint } from 'components/ActionsMenu/ActionsMenu.styled';

export const Food = () => {
    const [typeModal, setTypeModal] = useState({ open: false, value: null })
    const [suppliersModal, setSuppliersModal] = useState({ open: false, value: null })
    const [ingredientModal, setIngredientModal] = useState({ open: false, value: null })
    const [dishesModal, setDishesModal] = useState({ open: false, id: null })

    const [dishesParams, setDishesParams] = useState({ page: 1, limit: 5 })
    const [typesParams, setTypesParams] = useState({ page: 1, limit: 5 })
    const [suppliersParams, setSuppliersParams] = useState({ page: 1, limit: 5 })
    const [ingredientParams, setIngredientParams] = useState({ page: 1, limit: 5 })

    const { dishes, mealTypes, mealSuppliers, mealIngredients } = useSelector((state: RootState) => state.food)

    const navigate = useNavigate()

    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        dispatch(getDishes(dishesParams))
    }, [dishesParams])
    useEffect(() => {
        dispatch(getMealTypes(typesParams))
    }, [typesParams])
    useEffect(() => {
        dispatch(getMealSuppliers(suppliersParams))
    }, [suppliersParams])
    useEffect(() => {
        dispatch(getMealIngredients(ingredientParams))
    }, [ingredientParams])

    useEffect(() => {
        return (() => {
            dispatch(clearFood())
        })
    }, [])

    const handleDelete = (id: number, fn: any, setParams: any, noItems: boolean, word: string) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(fn(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems,
                },
                word: 'delete ' + word,
            }),
        )
    }

    const handleDeleteDish = (id: number) => {
        handleDelete(id, deleteDish, setDishesParams, dishes.data.length < 2, 'dish')
    }
    const handleDeleteMealType = (id: number) => {
        handleDelete(id, deleteMealType, setTypesParams, mealTypes.data.length < 2, 'meal type')
    }
    const handleDeleteMealSupplier = (id: number) => {
        handleDelete(id, deleteMealSupplier, setSuppliersParams, mealSuppliers.data.length < 2, 'meal supplier')
    }
    const handleDeleteMealIngredient = (id: number) => {
        handleDelete(id, deleteIngredient, setIngredientParams, mealIngredients.data.length < 2, 'ingredient')
    }

    const getSuppliersModalValues = (item: IMealSupplierSingleResponse): IMealSupplierModalState => {
        const values: IMealSupplierModalState = {
            ...item,
            dietaryPreferenceTypes: item.dietaryPreferenceTypes.map(p => (({ value: p, label: dietaryPreferences.find(dp => dp.value == p).label })))
        }
        return values
    }

    return <>
        <NavBar />
        <PageWrapper noFooter >
            <Flex between center mb='16'>
                <MainHeadline>Food</MainHeadline>
                <HideOnBreakpoint>
                    <Button width='150' orange onClick={() => navigate('/hr/food/eligible-employees')} >Employees</Button>
                    <Button width='150' orange onClick={() => navigate('/hr/food/company-settings')} >Settings</Button>
                    <Button width='150' orange onClick={() => navigate('/hr/food/provisioning')} >Provisioning</Button>
                    <Button width='150' orange onClick={() => navigate('/hr/food/items')} >Items</Button>
                </HideOnBreakpoint>
                <ActionsMenuBreakpoint>
                    <ActionsMenu
                        actions={[
                            { label: 'Employees', onClick: () => navigate('/hr/food/eligible-employees'), orange: true },
                            { label: 'Settings', onClick: () => navigate('/hr/food/company-settings'), orange: true },
                            { label: 'Provisioning', onClick: () => navigate('/hr/food/provisioning'), orange: true },
                            { label: 'Items', onClick: () => navigate('/hr/food/items'), orange: true },
                        ]}
                    />
                </ActionsMenuBreakpoint>
            </Flex>
            <TablesGrid>
                <FoodTableContainer>
                    <Flex width='100%' between  >
                        <BodyText weight='bold' >MEAL TYPES</BodyText>
                        <Button orange onClick={() => setTypeModal({ value: null, open: true })}>Add</Button>
                    </Flex>
                    {!mealTypes?.data?.length ? <NoItems title='meal types' /> : <Table >
                        <Th minWidth={0}>
                            <Td w='95%' noTooltip text='NAME' />
                            <Td w='5%' />
                        </Th>
                        {
                            mealTypes?.data?.map((item: INameId) => {
                                return (
                                    <Tr small minWidth={0} key={item.id}>
                                        <Td w='95%' text={item?.name} />
                                        <Td w='5%' />
                                        <Options
                                            absolute
                                            item={item}
                                            title='Meal Type'
                                            openModal={() => setTypeModal({ open: true, value: item })}
                                            handleRemove={() => handleDeleteMealType(item.id)}
                                        />
                                    </Tr>
                                )
                            })}
                    </Table>}
                    <Flex width='100%' justend >
                        <Pagination
                            setPage={(page) => handlePagination(page, setTypesParams, 5)}
                            pageCount={Math.ceil(mealTypes.totalPages)}
                            forcePage={(typesParams.page ? typesParams.page : 1) - 1}
                        />
                    </Flex>
                </FoodTableContainer>
                <FoodTableContainer>
                    <Flex width='100%' between center >
                        <BodyText weight='bold' >MEAL SUPPLIERS</BodyText>
                        <Button orange onClick={() => setSuppliersModal({ value: null, open: true })}>Add</Button>

                    </Flex>
                    {!mealSuppliers?.data?.length ? <NoItems title='meal suppliers' /> : <Table>
                        <Th minWidth={0}>
                            <Td w='40%' noTooltip text='NAME' />
                            <Td w='55%' noTooltip text='DIETARY PREFERENCE' />
                            <Td w='5%' />
                        </Th>
                        {mealSuppliers?.data.map((item: IMealSupplierSingleResponse) => {
                            return (
                                <Tr small minWidth={0} key={item.id}>
                                    <Td w='40%' text={item?.name} />
                                    <Td w='55%' text={item?.dietaryPreferenceTypes?.map(p => dietaryPreferences.find(pr => pr.value == p).label).join(', ')} />
                                    <Td w='5%' />

                                    <Options
                                        absolute
                                        item={item}
                                        title='Meal Supplier'
                                        openModal={() => setSuppliersModal({ open: true, value: getSuppliersModalValues(item) })}
                                        handleRemove={() => handleDeleteMealSupplier(item?.id)}
                                    />
                                </Tr>
                            )
                        })}
                    </Table>}
                    <Flex width='100%' justend >
                        <Pagination
                            setPage={(page) => handlePagination(page, setSuppliersParams, 5)}
                            pageCount={Math.ceil(mealSuppliers.totalPages)}
                            forcePage={(suppliersParams.page ? suppliersParams.page : 1) - 1}
                        />
                    </Flex>
                </FoodTableContainer>
                {/* <FoodTableContainer>
                    <Flex width='100%' between center >
                        <BodyText weight='bold' >DISH LIST</BodyText>
                        <Button orange onClick={() => setDishesModal(({ id: null, open: true }))} >Add</Button>
                    </Flex>
                    {!dishes?.data?.length ? <NoItems title='dishes' /> : <Table>
                        <Th minWidth={0}>
                            <Td w='30%' noTooltip text='NAME' />
                            <Td w='30%' noTooltip text='MEAL TYPE' />
                            <Td w='35%' noTooltip text='DIETARY PREFERENCE' />
                            <Td w='5%' />
                        </Th>
                        {dishes?.data.map((item: IGetAllDishesSingleResponse) => {
                            return (
                                <Tr small minWidth={0} key={item.id}>
                                    <Td w='30%' text={item?.name} />
                                    <Td w='30%' text={item?.mealType?.name} />
                                    <Td w='35%' text={item?.dietaryPreferenceTypes?.map(p => dietaryPreferences.find(pr => pr.value == p).label).join(', ')} />
                                    <Td w='5%' />
                                    <Options
                                        absolute
                                        item={item}
                                        title='Dish'
                                        openModal={() => setDishesModal({ open: true, id: item.id })}
                                        handleRemove={() => handleDeleteDish(item?.id)}
                                    />
                                </Tr>
                            )
                        })}
                    </Table>}
                    <Flex width='100%' justend >
                        <Pagination
                            setPage={(page) => handlePagination(page, setDishesParams, 5)}
                            pageCount={Math.ceil(dishes.totalPages)}
                            forcePage={(dishesParams.page ? dishesParams.page : 1) - 1}
                        />
                    </Flex>
                </FoodTableContainer> */}
                {/* <FoodTableContainer>
                    <Flex width='100%' between center >
                        <BodyText weight='bold' >INGREDIENTS LIST</BodyText>
                        <Button orange onClick={() => setIngredientModal(({ value: null, open: true }))}>Add</Button>
                    </Flex>
                    {!mealIngredients?.data?.length ? <NoItems title='ingredients' /> : <Table>
                        <Th minWidth={0}>
                            <Td w='40%' noTooltip text='NAME' />
                            <Td w='55%' noTooltip text='UNIT' />
                            <Td w='5%' />
                        </Th>
                        {mealIngredients &&
                            mealIngredients.data.map((item: IIngredientSingleResponse) => {
                                return (
                                    <Tr small minWidth={0} key={item.id}>
                                        <Td w='40%' text={item?.name} />
                                        <Td w='55%' text={item?.unit.name} />
                                        <Td w='5%' />
                                        <Options
                                            absolute
                                            item={item}
                                            title='Ingredient'
                                            openModal={() => setIngredientModal({ open: true, value: { ...item, unit: { value: item.unit.id, label: item.unit.name } } })}
                                            handleRemove={() => handleDeleteMealIngredient(item.id)}
                                        />
                                    </Tr>
                                )
                            })}
                    </Table>}
                    <Flex width='100%' justend >
                        <Pagination
                            setPage={(page) => handlePagination(page, setIngredientParams, 5)}
                            pageCount={Math.ceil(mealIngredients.totalPages)}
                            forcePage={(ingredientParams.page ? ingredientParams.page : 1) - 1}
                        />
                    </Flex>
                </FoodTableContainer> */}
            </TablesGrid>
        </PageWrapper>
        {typeModal.open && <MealTypeModal value={typeModal.value} closeModal={() => setTypeModal(prev => ({ ...prev, open: false }))} />}
        {suppliersModal.open && <MealSuppliersModal value={suppliersModal.value} closeModal={() => setSuppliersModal(prev => ({ ...prev, open: false }))} />}
        {ingredientModal.open && <IngredientsModal value={ingredientModal.value} closeModal={() => setIngredientModal(prev => ({ ...prev, open: false }))} />}
        {dishesModal.open && <DishesModal id={dishesModal.id} closeModal={() => setDishesModal(prev => ({ ...prev, open: false }))} />}
    </>
}